import {
  FormikInsured,
  Gender,
  GroupAsset,
  Nationality,
  YesNoAnswersNew,
} from "src/types";
import {
  deleteEmptyKeys,
  generateFiscalCode,
  getDateFromFiscalCode,
} from "src/utils";

const fromGroupAssetNationality = (nationality: string): Nationality => {
  switch (nationality?.toUpperCase()) {
    case "IT":
    default:
      return Nationality.IT;
    case "EXT":
      return Nationality.EXT;
  }
};

const fromGroupAssetFcQuestion = (question?: string): YesNoAnswersNew => {
  switch (question) {
    case "yes_id":
    default:
      return YesNoAnswersNew.YES;
    case "no_id":
      return YesNoAnswersNew.NO;
  }
};

const toGroupAssetNationality = (nationality: Nationality): string => {
  switch (nationality) {
    case Nationality.IT:
    default:
      return "IT";
    case Nationality.EXT:
      return "EXT";
  }
};

export const fromGroupAsset = (
  groupAsset: GroupAsset,
  index: number
): FormikInsured => {
  const assicurato = groupAsset.assicurato;

  const fcQuestion = fromGroupAssetFcQuestion(assicurato.fiscalCodeQuestion);

  return {
    id: index.toString(),
    insuredName: assicurato.nome,
    insuredSurname: assicurato.cognome,
    insuredBirth: assicurato.dataNascita,
    insuredBirthNation: assicurato.nazioneNascita,
    insuredBirthPlace: assicurato.luogoNascita,
    insuredFc:
      assicurato.codiceFiscale,
    insuredGender: assicurato.sesso || Gender.M,
    insuredFcQuestion: fcQuestion,
    insuredNationality: fromGroupAssetNationality(assicurato.nazionalita),
  };
};

export const toGroupAsset = (insured: FormikInsured): GroupAsset => {
  const {
    insuredName,
    insuredSurname,
    insuredNationality,
    insuredFcQuestion,
    insuredFc,
    insuredBirth,
    insuredBirthNation,
    insuredBirthPlace,
    insuredGender,
  } = insured;

  return deleteEmptyKeys({
    assicurato: {
      nome: insuredName?.trim(),
      cognome: insuredSurname?.trim(),
      nazionalita: toGroupAssetNationality(insuredNationality),
      codiceFiscale:
        insuredFcQuestion === YesNoAnswersNew.YES
          ? insuredFc?.toUpperCase()
          : generateFiscalCode({
              name: insuredName,
              surname: insuredSurname,
              birthDate: insuredBirth,
              birthPlace: insuredBirthPlace,
              gender: insuredGender,
            }),
      dataNascita:
        insuredFcQuestion === YesNoAnswersNew.NO
          ? insuredBirth
          : getDateFromFiscalCode(insuredFc?.toUpperCase()),
      nazioneNascita:
        insuredFcQuestion === YesNoAnswersNew.NO ? insuredBirthNation : "",
      luogoNascita:
        insuredFcQuestion === YesNoAnswersNew.NO ? insuredBirthPlace : "",
      sesso: insuredFcQuestion === YesNoAnswersNew.NO ? insuredGender : "",
    },
  });
};
